import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "", {
  auth: {
    // Manual exchange in auth.js (code only + HashRouter redirect).
    detectSessionInUrl: false,
    flowType: "pkce",
    persistSession: true,
    autoRefreshToken: true,
  },
});

/** Origin + pathname only (no hash). Required for OAuth PKCE with HashRouter. */
export function authRedirectTo() {
  const { origin, pathname } = window.location;
  return `${origin}${pathname || "/"}`;
}
